import { Toro } from '../common/enumerations';
import { IToroAccount } from './IToroAccount';

export class ToroAccountSimple implements IToroAccount
{

    constructor(accountType: Toro.AccountType, json: object = null, skipObjectAssign: boolean = false)
    {
        if (!skipObjectAssign && json)
        {
            Object.assign(this, json);
        }

        this.AccountType = accountType;
    }

    public CostPlanId: number;
    public Description: string;
    public Id: number;
    public Name: string;
    public OrganizationId: number;
    public ParentId: number;
    public WhenCreated: string;
    public WhenLastUpdated: string;

    public AccountType: Toro.AccountType = Toro.AccountType.Administered;
}
